module.exports = __webpack_public_path__ + "static/media/website.19bdbdb7.png";